/**
 * Org-level "Client Brain" context. Mirrors the backend `KboFlowOrganizationContext`
 * (Data.Models.KboFlow.Context), stored as JSON in OrganizationConfiguration at key
 * "kbo-flow-context". KBo uses this to decide what to surface and how to frame findings.
 *
 * Hierarchy/therapeutic-area rows are loaded separately from the live service hierarchy.
 */

// String values match the backend enum's JsonStringEnumConverter output.
export enum ClientType {
    Pharma = "Pharma",
    Payer = "Payer",
    Provider = "Provider",
    Other = "Other",
}

export interface GoalsAndPriorities {
    value: string;
    modifiedBy?: string;
    /** ISO date. */
    modifiedOn?: string;
}

export interface ProgramEvent {
    id: string;
    /** ISO date the event took place. */
    startDate: string;
    description: string;
    createdOn?: string;
    createdBy?: string;
}

export interface OrganizationContext {
    clientType?: ClientType;
    goalsAndPriorities?: GoalsAndPriorities;
    programEvents: ProgramEvent[];
}

export interface HierarchyRow {
    id: string;
    hierarchyName: string;
    therapeuticAreas: TherapeuticAreaDto[];
    description: string;
}

export interface TherapeuticAreaDto {
    id: string;
    name: string;
}
